import React from "react";

export class CookiePolicyNO extends React.Component {
    render() {
        return (
            <>
                <p>
                    Sist oppdatert: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    Dette dokumentet er utarbeidet i henhold til EU-forordning 2016/679 ("GDPR") for å gjøre det mulig for brukere å forstå hvilke informasjonskapsler som er installert når de bruker en DeepUnity PACSonWEB-portal ("nettstedet").
                </p>
                <h2>1. Behandlingsansvarlig og personvernombud</h2>
                <p>
                    DH Healthcare GmbH, med hovedkontor i Konrad-Zuse-Platz 1-3, 53227 Bonn, Tyskland, er behandlingsansvarlig for personopplysningene (dataene) til brukerne av nettstedet, som samles inn ved hjelp av informasjonskapsler. For enhver forespørsel er det mulig å skrive til DH Healthcare GmbH til ovennevnte postadresse eller via e-postadressen.
                    <br />
                    <br />
                    DH Healthcare GmbH har utnevnt et personvernombud ("DPO"), som kan kontaktes på Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Data behandlet av DH Healthcare GmbH</h2>
                <p>
                    Navigasjonen på nettstedet innebærer bruk av informasjonskapsler, korte tekststrenger som nettstedene som besøkes sender til brukerens nettleser, hvor de lagres og deretter overføres til de samme nettstedene ved senere besøk. Mens brukeren surfer på et nettsted, kan han/hun også motta informasjonskapsler på datamaskinen sin fra andre nettsteder eller webservere enn det han/hun besøker (såkalte "tredjeparts"-informasjonskapsler). Det er mulig å skille mellom:
                    <br />
                    <br />
                    a) tekniske informasjonskapsler, som gjør det mulig å utføre aktiviteter knyttet til driften av nettstedet,
                    <br />
                    <br />
                    b) profileringskapsler, som brukes til å analysere brukeratferd og, om nødvendig, sende reklamemeldinger i tråd med preferansene brukeren har gitt uttrykk for under navigering,
                    <br />
                    <br />
                    c) lokal lagring, som gjør det mulig å utføre aktiviteter knyttet til driften av nettstedet.
                </p>
                <p>
                    <br />
                    Dette nettstedet bruker følgende informasjonskapsler:
                </p>
                <h3>a) Tekniske informasjonskapsler</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Navn</th>
                            <th>Vert</th>
                            <th>Kategori</th>
                            <th>Beskrivelse</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>DeepUnity PACSonWEB-portalautentisering</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>DeepUnity PACSonWEB-portalens økt-ID</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>Denne informasjonskapselen settes hvis du velger å tillate alle informasjonskapsler, og registrerer når den ble satt.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>Registrerer språkvalget straks det endres manuelt</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>Registrerer språkvalget straks det endres manuelt (nettleserspråket brukes som standard)</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>kundeportalen du logget inn på</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>Registrerer de lokale bildebufferne som er knyttet til brukeren</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Nødvendig</td>
                            <td>Dette brukes til å lagre statusen på tvers av en ekstern påloggingsrunde. Dette er nødvendig av sikkerhetsgrunner for å forhindre CSRF- og replay-angrep. Informasjonskapselen blir kryptert.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Funksjonell</td>
                            <td>Denne informasjonskapselen settes hvis du velger å tillate alle informasjonskapsler, og registrerer når den ble satt.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Informasjonskapsler for analyse/profilering</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Navn</th>
                            <th>Vert</th>
                            <th>Varighet</th>
                            <th>Kategori</th>
                            <th>Beskrivelse</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 år</td>
                            <td>Analytisk</td>
                            <td>Brukes til å skille mellom brukere.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 timer</td>
                            <td>Analytisk</td>
                            <td>Brukes til å skille mellom brukere.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 år</td>
                            <td>Analytisk</td>
                            <td>Brukes til å opprettholde øktstatus.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Lokal lagring (vert: Dobco; Kategori: Nødvendig)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Navn</th>
                            <th>Beskrivelse</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td> den siste gangen du åpnet merknadene</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td> ID for bruk av HomeReading.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td> Registrerer om opplæringen allerede har blitt vist.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td> Foretrukne innstillinger for å dele en studie.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td> Foretrukket innstilling for å skrive ut en undersøkelse.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td> Kundeportalen du logget inn på.</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td> Registrerer om retningslinjene for informasjonskapsler allerede har blitt vist.</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td> Opptak av de viktige nyhetsfaktaene som allerede er vist.</td>
                        </tr>
                        <tr>
                            <td>Rapportfontstørrelse</td>
                            <td> Skriftstørrelse på rapporten i visningsvinduet.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> Hvordan du logget inn (pasient/lege).</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>Identifiserer nettleseren din på en unik måte i DeepUnity PACSonWEB. Den brukes til å avgjøre om du blir bedt om å oppgi en OTP under pålogging eller ikke.</td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Lagrer det sist brukte lydvolumnivået.</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td>Lagrer ditt foretrukne talegjenkjenningsspråk.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Lagrer den foretrukne skaleringsfaktoren og tilsvarende startoppløsning.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Identifiserer hvilke nyhets-popup-vinduer du ikke ønsker å se igjen.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Mens nødvendige tekniske informasjonskapsler ikke kan avslås av brukeren av nettstedet, ettersom de er strengt funksjonelle for selve nettstedet, kan brukeren fritt velge å godta eller nekte bruk av analyse-, profilerings- og ikke strengt nødvendige informasjonskapsler. Brukeren kan angi og gjennomgå sine valg vedrørende informasjonskapsler ved hjelp av funksjonen "Endre innstillingene for informasjonskapsler" som er tilgjengelig på nettstedet (avsnittet "Juridisk")
                </p>
                <h2>3. Formål og rettslig grunnlag for behandlingen</h2>
                <p>
                    Vi har følgende formål med å bruke informasjonskapsler:
                    <br />
                    <br />
                    3.1 For å muliggjøre navigering på nettstedet, med smidig funksjon. Det rettslige grunnlaget for behandlingen er levering til brukere av tjenester relatert til nettstedet og Dedalus' legitime interesse i å ha et funksjonelt nettsted.
                    <br />
                    3.2 For å oppfylle eventuelle forpliktelser i henhold til gjeldende lover, forskrifter eller EU-lovgivning, eller for å etterkomme forespørsler fra myndighetene. Det rettslige grunnlaget for behandlingen er Dedalus' forpliktelse til å overholde ufravikelig lovgivning.
                    <br />
                    3.3 Analysere brukeratferd og eventuelt sende brukeren reklamemeldinger i tråd med de preferansene brukeren har gitt uttrykk for under navigasjonen. Det rettslige grunnlaget for behandling i dette tilfellet, er samtykke fra den berørte parten.
                    <br />
                    3.4 For behov for forsvar av rettighetene til Dedalus i forbindelse med eventuelle tvister, selv i retten. Det rettslige grunnlaget for behandlingen er eierens berettigede interesse i å beskytte sine rettigheter. Det er valgfritt å oppgi opplysninger, men (unntatt i tilfeller av behandling basert på samtykke) manglende oppgivelse av opplysninger vil hindre Behandlingsansvarlig i å tillate navigering på nettstedet.
                </p>
                <h2>4. Mottakere av dataene</h2>
                <p>
                    Dataene kan kommuniseres:
                    <br />
                    <br />
                    (a) til tredjeparter som trenger å utføre spesifikke aktiviteter i forbindelse med opplysningene, i samsvar med formålet med behandlingen, eller til tjenesteleverandører til den behandlingsansvarlige.
                    <br />
                    (b) til myndigheter, enheter og/eller parter som opplysningene må utleveres til i henhold til bindende juridiske eller kontraktsmessige bestemmelser.
                    <br />
                    (c) under andre omstendigheter, for eksempel ved oppkjøp fra og salg til potensielle tredjepartsselskaper, når vi forventer å selge eller overføre deler av eller hele virksomheten vår.
                </p>
                <h2>5. Overføring av data utenfor Det europeiske økonomiske samarbeidsområdet (EØS)</h2>
                <p>
                    Når det gjelder eventuell overføring av data til land som ikke tilhører Det europeiske økonomiske samarbeidsområdet, vil behandlingen skje i henhold til en av de lovlig tillatte metodene, og derfor gjennom valg av mottakere som er etablert i land som EU-kommisjonen anser som tilstrekkelige, eller gjennom fastsettelse av standard kontraktsklausuler.
                </p>
                <h2>6. Oppbevaring av data</h2>
                <p>
                    Opplysningene vil bare bli oppbevart så lenge det er nødvendig for de formålene de ble samlet inn for, med respekt for prinsippene om bevaringsbegrensning og minimering. Varigheten av informasjonskapslene er definert mer presist i forrige avsnitt 2. For opplysninger som behandles på grunnlag av samtykke fra den berørte parten, er det spesifisert at de vil bli oppbevart inntil samtykket trekkes tilbake.
                </p>
                <h2>7. De registrertes rettigheter</h2>
                <p>
                    Når de relevante rettslige forutsetningene foreligger, kan den registrerte be den behandlingsansvarlige eller personvernombudet om innsyn i sine opplysninger, om at de rettes eller slettes, protestere mot behandlingen av dem, be om begrensning av behandlingen i de tilfellene som er fastsatt i artikkel 18 i GDPR, samt få utlevert opplysningene om seg selv i et strukturert, alminnelig anvendt og maskinlesbart format i de tilfellene som er fastsatt i artikkel 20 i GDPR.
                    <br />
                    <br />
                    I tillegg har brukeren når som helst rett til å tilbakekalle et eventuelt samtykke til behandling, uten at det påvirker lovligheten av behandlingen som ble utført av Behandlingsansvarlig før tilbakekallingen.
                    <br />
                    <br />
                    Forespørsler skal sendes skriftlig til behandlingsansvarlig, til adressene som er angitt ovenfor.
                    <br />
                    Den berørte parten kan under alle omstendigheter klage til Garantisten for beskyttelse av personopplysninger hvis han mener at behandlingen av hans opplysninger er i strid med gjeldende regelverk.
                </p>
            </>
        );
    }
}
